/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useState, useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperOptions } from 'swiper'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import PhotoSwiper from '../PhotoSwiper'
import Image from '../Image'
// import { AiFillCloseCircle } from 'react-icons/ai'

import 'swiper/css'
import { ProductPageSensor } from '../../utils/bloomchicdata/page/productpage'
import { useIsomorphicLayoutEffect } from '../../utils/helpers'

const productPageSensorMod = () =>
  import('../../utils/bloomchicdata/page/productpage')

let productPageSensor: ProductPageSensor | null

// 小屏
const config: SwiperOptions = {
  autoplay: false,
  slidesPerView: 'auto',
  spaceBetween: 4,
  centeredSlides: true,
  loop: true,
  observer: true,
  observeParents: true,
}
// 大屏
const config2: SwiperOptions = {
  autoplay: false,
  spaceBetween: 0,
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
}

interface Props {
  data: any
  initialSlide?: number
  onSelect?: (index: string | number) => any
}

const ProductsSwiper: FC<Props> = ({ initialSlide = 0, data }) => {
  const [curIndex, setCurIndex] = useState(initialSlide)
  const [isMax, setIsMax] = useState<boolean>()
  const [swiperConfig, setSwiperConfig] = useState<SwiperOptions>()
  const smallSlider = useRef<any>({})
  const [swiperObj, setSwiperObj] = useState<any>({})
  const [open, setOpen] = useState(false)
  const [images, setImages] = useState<any[]>(data.images.edges)
  // 获取视差宽度与swiper参数
  const getClientWidth = () => document?.body.clientWidth >= 768
  const getSwiperConfig = () => {
    if (getClientWidth()) {
      return config2
    }
    return config
  }
  const onSlideChange = (index: number) => {
    setCurIndex(index)
  }
  const smallSlideTo = (idx: number) => {
    smallSlider.current.scrollTop = idx * 112 - 60 > 0 ? idx * 112 - 60 : 0
  }
  const slideTo = (idx: number) => {
    if (!swiperObj && idx <= images.length) {
      return
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    swiperObj && swiperObj.slideTo && swiperObj?.slideTo(idx)
    smallSlideTo(idx)
  }

  const onAsyncSlideChange = (index: number) => {
    setCurIndex(index)
    slideTo(index)
  }

  const imageList = images.map(
    (item: any) => item.node.src || item.node.originalSrc
  )
  const debounceSetOpen = debounce(
    (e) => {
      setOpen(e)
    },
    200,
    {
      trailing: true,
    }
  )
  const openPriview = (idx: any) => {
    setCurIndex(idx)
    debounceSetOpen(true) // 节流一下
    productPageSensor?.BigPictureClick(data)
  }
  const setSwiperConfigs = () => {
    setIsMax(getClientWidth())
    setSwiperConfig(getSwiperConfig())
  }
  const resetSwiper = () => {
    setSwiperConfigs()
    swiperObj?.update(true)
  }

  const throttleResetSwiper = throttle(resetSwiper, 2000) // 节流一下

  useEffect(() => {
    setSwiperConfigs()
    setImages(data.images.edges)
  }, [data])

  useIsomorphicLayoutEffect(() => {
    if (process.browser && data) {
      productPageSensorMod().then((mod) => {
        productPageSensor = mod.default
        productPageSensor?.resetHasBigPictureClick()
      })
    }
  }, [data])

  useEffect(() => {
    if (initialSlide !== null) {
      slideTo(initialSlide)
    }
  }, [initialSlide])

  return images && images.length > 0 && swiperConfig ? (
    <div className="w-full flex items-stretch">
      <div className="hidden sm:hidden md:block pr-5 relative w-24">
        <div
          className="absolute top-0 left-0 h-full overflow-y-auto overflow-x-hidden nobar"
          ref={smallSlider}
        >
          {images.map((i: any, idx: number) => (
            <div
              key={i.node.src}
              style={{
                width: '75px',
                height: '100px',
              }}
              className={`cursor-pointer relative border-2 border-black ${
                idx === curIndex ? 'border-gray' : 'border-white'
              } ${idx === images.length - 1 ? '' : 'mb-3'}`}
            >
              <Image
                src={i.node.src || i.node.originalSrc}
                alt={i.title || ''}
                layout="fill"
                onClick={() => slideTo(idx)}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-1 w-0 md:mr-16">
        <Swiper
          {...swiperConfig}
          initialSlide={curIndex}
          onSlideChange={(e) => onSlideChange(e?.realIndex)}
          onSwiper={(swiper: any) => setSwiperObj(swiper)}
          onResize={throttleResetSwiper}
          className="w-full"
        >
          {images.map((i: any, idx: any) => (
            <SwiperSlide
              key={i.node.src}
              style={{
                width: `${isMax ? '100' : 0.76 * 100}%`,
                // maxWidth: `${isMax ? '100' : 0.76 * 100}%`,
                height: '0',
                paddingBottom: `${isMax ? 133 : 103}%`,
              }}
            >
              <Image
                src={i.node.src || i.node.originalSrc}
                alt={i.title || ''}
                layout="fill"
                onClick={() => openPriview(idx)}
                className="cursor-zoom imgref"
              />
            </SwiperSlide>
          ))}
          <div className="z-50 md:hidden absolute bottom-4 left-1/2 transform -translate-x-1/2 text-gray-50 text-xs bg-gray-900 bg-opacity-60 w-10 min-w-min flex justify-center items-center rounded-lg h-4">
            {curIndex + 1}/{images?.length}
          </div>
        </Swiper>
      </div>
      <PhotoSwiper
        images={imageList}
        open={open}
        initialSlide={curIndex}
        onSlideChange={onAsyncSlideChange}
        onOpenChange={() => {
          setOpen(false)
        }}
      />
    </div>
  ) : (
    <></>
  )
}

export default ProductsSwiper
